"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionDataset = void 0;
const interfaces_1 = require("@build-5/interfaces");
const fetch_utils_1 = require("../fetch.utils");
const observable_1 = require("../get/observable");
const Dataset_1 = require("./Dataset");
class TransactionDataset extends Dataset_1.DatasetClass {
    constructor() {
        super(...arguments);
        this.creditUnrefundable = (this.sendRequest(interfaces_1.WEN_FUNC.creditUnrefundable));
        this.getBadgesForMemberLive = (member, orderBy = ['createdOn'], startAfter) => {
            const fieldName = ['member', 'type', 'payload.type'];
            const params = {
                dataset: this.dataset,
                fieldName,
                fieldValue: [member, interfaces_1.TransactionType.AWARD, interfaces_1.TransactionPayloadType.BADGE],
                operator: fieldName.map(() => interfaces_1.Opr.EQUAL),
                startAfter,
                orderBy,
                orderByDir: orderBy.map(() => 'desc'),
            };
            return this.getManyAdvancedLive(params);
        };
        this.getTopTransactionsLive = (orderBy = ['createdOn'], startAfter, member, previousOwner) => {
            const includedTypes = [
                interfaces_1.TransactionType.PAYMENT,
                interfaces_1.TransactionType.BILL_PAYMENT,
                interfaces_1.TransactionType.CREDIT,
                interfaces_1.TransactionType.CREDIT_NFT,
                interfaces_1.TransactionType.MINT_COLLECTION,
                interfaces_1.TransactionType.WITHDRAW_NFT,
                interfaces_1.TransactionType.MINT_TOKEN,
                interfaces_1.TransactionType.UNLOCK,
                interfaces_1.TransactionType.CREDIT_TANGLE_REQUEST,
                interfaces_1.TransactionType.VOTE,
            ];
            const fieldName = includedTypes.map(() => 'type');
            const fieldValue = includedTypes;
            const operator = includedTypes.map(() => interfaces_1.Opr.IN);
            if (member) {
                fieldName.push('member');
                fieldValue.push(member);
                operator.push(interfaces_1.Opr.EQUAL);
            }
            if (previousOwner) {
                fieldName.push('payload.previousOwner');
                fieldValue.push(previousOwner);
                operator.push(interfaces_1.Opr.EQUAL);
            }
            const params = {
                dataset: this.dataset,
                fieldName,
                fieldValue,
                operator,
                startAfter,
                orderBy,
                orderByDir: orderBy.map(() => 'desc'),
            };
            return this.getManyAdvancedLive(params);
        };
        this.getNftOffersLive = (nft, startAfter) => {
            const params = {
                dataset: this.dataset,
                fieldName: ['type', 'payload.nft', 'createdOn', 'createdOn'],
                fieldValue: [
                    interfaces_1.TransactionType.PAYMENT,
                    nft.uid,
                    nft.auctionTo.toDate().toISOString(),
                    nft.auctionFrom.toDate().toISOString(),
                ],
                operator: [interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL, interfaces_1.Opr.LESS, interfaces_1.Opr.GREATER],
                startAfter,
                orderBy: ['createdOn'],
                orderByDir: ['desc'],
            };
            return this.getManyAdvancedLive(params);
        };
        this.getMembersBidsLive = (member, nft, currentAuction = false, startAfter) => {
            const fieldName = ['member', 'payload.nft', 'type', 'type'];
            const fieldValue = [
                member,
                nft.uid,
                interfaces_1.TransactionType.PAYMENT,
                interfaces_1.TransactionType.CREDIT,
            ];
            const operator = [interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL, interfaces_1.Opr.IN, interfaces_1.Opr.IN];
            if (currentAuction) {
                fieldName.push('createdOn', 'createdOn');
                fieldValue.push(nft.auctionTo.toDate().toISOString(), nft.auctionFrom.toDate().toISOString());
                operator.push(interfaces_1.Opr.GREATER, interfaces_1.Opr.LESS);
            }
            const params = {
                dataset: this.dataset,
                fieldName,
                fieldValue,
                operator,
                startAfter,
                orderBy: ['createdOn'],
                orderByDir: ['desc'],
            };
            return this.getManyAdvancedLive(params);
        };
        this.getLatestVotesForProposalLive = (proposal, member, startAfter) => {
            const fieldName = ['payload.proposalId', 'type'];
            const fieldValue = [proposal, interfaces_1.TransactionType.VOTE];
            const operator = [interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL];
            if (member) {
                fieldName.push('member');
                fieldValue.push(member);
                operator.push(interfaces_1.Opr.EQUAL);
            }
            const params = {
                dataset: this.dataset,
                fieldName,
                fieldValue,
                operator,
                startAfter,
                orderBy: ['createdOn'],
                orderByDir: ['desc'],
            };
            return this.getManyAdvancedLive(params);
        };
        this.getPaymentByTagLive = (tag) => {
            const params = {
                dataset: this.dataset,
                fieldName: ['type', 'payload.tag'],
                fieldValue: [interfaces_1.TransactionType.PAYMENT, tag],
            };
            const url = this.origin + interfaces_1.ApiRoutes.GET_MANY + (0, fetch_utils_1.toQueryParams)(Object.assign({}, params));
            return (0, observable_1.fetchLive)(this.apiKey, url);
        };
        this.getBySourceTransactionLive = (sourceTransaction) => {
            const params = {
                dataset: this.dataset,
                fieldName: ['payload.sourceTransaction', 'payload.walletReference.confirmed'],
                fieldValue: [sourceTransaction, true],
                operator: [interfaces_1.Opr.ARRAY_CONTAINS, interfaces_1.Opr.EQUAL],
            };
            const url = this.origin + interfaces_1.ApiRoutes.GET_MANY_ADVANCED + (0, fetch_utils_1.toQueryParams)(Object.assign({}, params));
            return (0, observable_1.fetchLive)(this.apiKey, url);
        };
    }
}
exports.TransactionDataset = TransactionDataset;
